/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-161
 */

"use strict"

import { oA } from "./index__part-160"
import /* [auto-meaningful-name] */React from /* 0 */"react"
import { memo } from /* 0 */"react"
import * as /* [auto-meaningful-name] */React1 from "react"
import * as /* [auto-meaningful-name] */Module_1061 from /* 1061 */"./1061"
import /* [auto-meaningful-name] */Module_10611 from /* 1061 */"./1061"
var cA = memo(function () {
  return React.createElement("div", {
    className: Module_10611.toolContent
  }, React.createElement("div", {
    className: Module_10611.wrapper
  }, React.createElement("div", {
    className: Module_10611.dataWatchContainer
  }, React.createElement(oA, null))))
})
export { cA }
